import { createSlice } from "@reduxjs/toolkit";
import { getTeleRoles } from "../reduxApi/teleRolesReduxApi";
const teleRoleSlice = createSlice({
    name: 'teleRole',
    initialState: {
    status: 'idel',
    teleRole: [],
    },
    reducers: {
        deleteTeleRolesAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.teleRole.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.teleRole.splice(index, 1);
                }
            });
        },     
        updateTeleRolesAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.teleRole.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.teleRole.splice(index, 1, action.payload )
            }
        },
        addTeleRolesAction: (state, action) => {
            console.log("action.payload",action.payload)
            const temp = action.payload.formData;
            console.log("action.payload2",temp);
            
            temp.ROWID = action.payload.ROWID;
            state.teleRole.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTeleRoles.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getTeleRoles.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("teleRoleSlice", action.payload)
                state.teleRole = action.payload.data.records;
                console.log("state.teleRole",state.teleRole);
                
            })
    }
})
export const { deleteTeleRolesAction, updateTeleRolesAction, addTeleRolesAction } = teleRoleSlice.actions
export default teleRoleSlice.reducer